import { saveAs } from 'file-saver';
import $ from 'jquery';
import moment from 'moment';
import React, { Component } from 'react';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';


class WarehouseQuery extends Component {


    constructor(props) {
        super(props);
        if (!Comm.ValidSession())
            return;


        var sid = Context.GetContext().Sid;
        var sorter = Comm.GetSorters({ session: sid, visible_only: true, from: moment().startOf('day').format("YYYYMMDD HH:mm:ss"), to: moment().endOf('day').format("YYYYMMDD HH:mm:ss") });
        sorter.splice(0, 0, { name: "" });
        var root = Comm.GetRoots({ session: sid });
        root.splice(0, 0, { name: "" });
        var users = Comm.Users(sid);
        users.splice(0, 0, { name: "" });
        //console.log("users", users);
        var GROUP_BY_LEADER_IN_WAREHOUSE_REPORT = 
            window.CONFIG && 
                window.CONFIG.GROUP_BY_LEADER_IN_WAREHOUSE_REPORT; // : 
                // process.env.REACT_APP_GROUP_BY_LEADER_IN_WAREHOUSE_REPORT
        this.state = {
            Q: "Q1",
            StartDate: moment().startOf('day'),
            EndDate: moment().endOf('day'),
            Sorter: sorter,
            Root: root,
            Users: users,
            ShowQty: true,
            GroupByLead: GROUP_BY_LEADER_IN_WAREHOUSE_REPORT === 1
        };

        this.ChangeStartDate = this.ChangeStartDate.bind(this);
        this.ChangeEndDate = this.ChangeEndDate.bind(this);
        this.Report = this.Report.bind(this);
        this.PrintLabel = this.PrintLabel.bind(this);
        this.ShowQ = this.ShowQ.bind(this);
        this.PrintElem = this.PrintElem.bind(this);
        this.Export = this.Export.bind(this);
    }


    ChangeStartDate(date) {
        var sid = Context.GetContext().Sid;

        var d1 = date;
        var d2 = this.state.EndDate;
        switch (this.state.Q) {
            case "Q1":
                //console.log({ session: sid, visible_only: true, from: moment(d1).format("YYYYMMDD HH:mm:ss"), to: moment(d2).format("YYYYMMDD HH:mm:ss") });

                var sorter = Comm.GetSorters({ session: sid, visible_only: true, from: moment(d1).format("YYYYMMDD HH:mm:ss"), to: moment(d2).format("YYYYMMDD HH:mm:ss") });
                sorter.splice(0, 0, { name: "" });

                this.setState({
                    StartDate: date,
                    Sorter: sorter
                });
                break;
            case "Q2":

                this.setState({
                    StartDate: date
                });
                break;
            case "Q3":

                this.setState({
                    StartDate: date
                });
                break;
            case "Q4":

                this.setState({
                    StartDate: date
                });
                break;
            default: break;
        }
    }

    ChangeEndDate(date) {
        var sid = Context.GetContext().Sid;
        var d1 = this.state.StartDate;
        var d2 = date;
        switch (this.state.Q) {
            case "Q1":
                var sorter = Comm.GetSorters({ session: sid, visible_only: true, from: moment(d1).format("YYYYMMDD HH:mm:ss"), to: moment(d2).format("YYYYMMDD HH:mm:ss") });
                sorter.splice(0, 0, { name: "" });


                this.setState({
                    EndDate: date,
                    Sorter: sorter
                });
                break;
            case "Q2":

                this.setState({
                    EndDate: date
                });
                break;
            case "Q3":

                this.setState({
                    EndDate: date
                });
                break;
            case "Q4":

                this.setState({
                    EndDate: date
                });
                break;
            default: break;
        };

    }


    Report(specialId) {
        
        var sid = Context.GetContext().Sid;
        var d1 = this.state.StartDate;
        var d2 = this.state.EndDate;
        var data = {};
        var result = "";
        if (specialId !== null) {
            switch (specialId) {
                case "currentavailability":
                    result = Comm.ReportQty({ session: sid, lang: Translation.CurrentLanguage().toLowerCase() });
                    break;
                case "total":
                    data = {
                        session: sid,
                        dt_from: moment(d1).format("YYYYMMDD HH:mm:ss"),
                        dt_to: moment(d2).format("YYYYMMDD HH:mm:ss")
                    };
                    data.lang = Translation.CurrentLanguage().toLowerCase();

                    result = Comm.ReportScalesSortingByOperator(data);
                    break;
                default: break;
            }

        }
        else {
            switch (this.state.Q) {
                case "Q1":
                    var group = $("#cbGroup").prop("checked");
                    var root = $("#ddlRoot").val();
                    var sorter = $("#ddlSorter").val();
                    var user = this.state.GroupByLead ? $("#ddlUser").val() : "";

                    data = {
                        session: sid,
                        from: moment(d1).format("YYYYMMDD HH:mm:ss"),
                        to: moment(d2).format("YYYYMMDD HH:mm:ss"),
                        grouped: group

                    };
                    if (sorter !== "")
                        data.sorter = sorter;
                    if (root !== "")
                        data.root = root;
                    if (user !== "")
                        data.user = user;
                    data.lang = Translation.CurrentLanguage().toLowerCase();
                    result = Comm.ReportPercent(data);
                    break;
                case "Q2":

                    data = {
                        session: sid,
                        date: moment(d2).format("YYYYMMDD HH:mm:ss")

                    };
                    data.lang = Translation.CurrentLanguage().toLowerCase();

                    result = Comm.ReportQty(data);
                    break;
                case "Q3":
                    var operator = $("#ddlOperator").val();
                    var withShoes = $("#cbWithShoes").prop("checked");
                    data = {
                        session: sid,
                        dt_from: moment(d1).format("YYYYMMDD HH:mm:ss"),
                        dt_to: moment(d2).format("YYYYMMDD HH:mm:ss"),
                        with_shoes: withShoes
                    };
                    if (operator !== "")
                        data.operator = operator;
                    data.lang = Translation.CurrentLanguage().toLowerCase();

                    result = Comm.ReportScalesSorting(data);
                    break;
                case "Q4":
                    var inArticle = $("#ddlInArticle").val();
                    var percent = $("#cbPercent").prop("checked");
                    data = {
                        session: sid,
                        dt_from: moment(d1).format("YYYYMMDD HH:mm:ss"),
                        dt_to: moment(d2).format("YYYYMMDD HH:mm:ss"),
                        root: inArticle,
                        percent: percent
                    };
                    data.lang = Translation.CurrentLanguage().toLowerCase();

                    result = Comm.ReportOriginalSorting(data);
                    break;
                default: break;
            }
        }
        if (result) {
            result.html = result.html + "<nocache id='" + moment().format() + "'/>";
        }

        //result.html = result.html.replace(/<table /, "<table ");

        this.setState({
            html: result ? result.html : null,
            jsonResult: result && result.result ? result.result : null,
            Landscape: this.state.Q === "Q4",
            specialId,
            data
        });
        //alert(result.html);
    }

    PrintElem() {
        var mywindow = window.open('', 'PRINT', 'height=400,width=600');


        mywindow.document.write('<html><head><title>' + document.title + '</title>');
        if (this.state.Landscape)
            mywindow.document.write('<style>@media print {@page {size: landscape}}</style>');

        mywindow.document.write('</head><body >');
        //mywindow.document.write('<h1>' + document.title + '</h1>');

        let innerHtml = this.state.html;
        if (this.state.GroupByLead && this.state.Q === "Q1") {
            var CUSTOMER = window.CONFIG && window.CONFIG.CUSTOMER; // : process.env.REACT_APP_CUSTOMER;
            innerHtml = CUSTOMER === "HUMANA" ?
                document.getElementById("dReport").outerHTML :
                document.getElementById("tabJsonResult").outerHTML;


            console.log("innerHtml", innerHtml);
        }

        mywindow.document.write(innerHtml);
        mywindow.document.write('</body></html>');
        this.RotateColumns(mywindow.document);
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;
    }

    Export() {
        let innerHtml = this.state.html;
        let sid = Context.GetContext().Sid;
        
        var CUSTOMER = window.CONFIG && window.CONFIG.CUSTOMER; // : process.env.REACT_APP_CUSTOMER;
        if (CUSTOMER === "HUMANA") {
            let result;
            let data = {
                ...this.state.data
            };
            switch (this.state.Q) {
                case "Q1": {  
                    data.export = 1; // added by Viktor based on request by Pavel on 01.03.2024 (spacing the thousands)                 
                    result = Comm.ReportPercent(data);                    
                    break;
                }
                case "Q2": {
                    data.export = 1; // added by Viktor based on request by Pavel on 01.03.2024 (spacing the thousands)      
                    if (this.state.specialId) {
                        result = Comm.ReportQty({ session: sid, lang: Translation.CurrentLanguage().toLowerCase(), export: 1 });
                    } else {
                        result = Comm.ReportQty(data); 
                    }
                    break;
                }
                case "Q3": {
                    data.export = 1; // added by Viktor based on request by Pavel on 01.03.2024 (spacing the thousands)  
                    if (this.state.specialId) {
                        result = Comm.ReportScalesSortingByOperator(data);
                    } else {
                        result = Comm.ReportScalesSorting(data);
                    }
                    break;
                }
                case "Q4": {
                    result = Comm.CallGetServerFunction("report/scale_sorting_by_sorter_for_export", data);
                    break;
                }
                default: break;
            }
            if (result && +result.code === 0) {
                innerHtml = result.html ? result.html + "<nocache id='" + moment().format() + "'/>" : null;
            }
            console.log("inner", innerHtml)
        }
        
        var html = "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8' /></head><body>" + innerHtml + "</body></html>"
        var file = new Blob([html]);

        if (this.state.GroupByLead && this.state.Q === "Q1") {
            innerHtml = document.getElementById("tabJsonResult").outerHTML;
        }
        html = "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8' /></head><body>" + innerHtml + "</body></html>"
        file = new Blob([html]);
        saveAs(file, "export.xls");
    }


    IsIe() {
        if (navigator.userAgent.indexOf('MSIE') !== -1)
            var detectIEregexp = /MSIE (\d+\.\d+);/ //test for MSIE x.x
        else // if no "MSIE" string in userAgent
            detectIEregexp = /Trident.*rv[ :]*(\d+\.\d+)/ //test for rv:x.x or rv x.x where Trident string exists

        var match = detectIEregexp.exec(navigator.userAgent);
        if (match) { //if some form of IE
        // if (detectIEregexp.test(navigator.userAgent)) { //if some form of IE
            var ieversion = +(match[1]); // capture x.x portion and store as a number
            // var ieversion = new Number(RegExp.$1) // $1 is obsolete, new Number as constructor is not recommended
            if (ieversion >= 12)
                return true;
            else if (ieversion >= 11)
                return true;
            else if (ieversion >= 10)
                return true;
            else if (ieversion >= 9)
                return true;
            else if (ieversion >= 8)
                return true;
            else if (ieversion >= 7)
                return true;
            else if (ieversion >= 6)
                return true;
            else if (ieversion >= 5)
                return true;
        }
        else {
            return false;
        }
    }


    PrintLabel() {
        if (!this.IsIe()) {
            alert(Translation.Trans("ieonly"));
            return;
            // insert conditional IE code here
        }
        var printWindow = window.open();
        printWindow.document.open('text/plain')
        printWindow.document.write("кооооооооооооооор");
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    }

    ShowQ(id) {
        var state = {
            Q: "Q" + id,
            // StartDate: moment().startOf('day'),
            // EndDate: moment().endOf('day'),
            html: null

        };
        var sid = Context.GetContext().Sid;


        switch (id) {
            case 1:
                var sorter = Comm.GetSorters({ session: sid, visible_only: true, from: moment().startOf('day').format("YYYYMMDD HH:mm:ss"), to: moment().endOf('day').format("YYYYMMDD HH:mm:ss") });
                sorter.splice(0, 0, { name: "" });
                var root = Comm.GetRoots({ session: sid });
                root.splice(0, 0, { name: "" });
                state.Sorter = sorter;
                state.Root = root;
                break;
            case 2:
                break;
            case 3:
                var operator = Comm.Operators(sid);
                operator.splice(0, 0, { operator: { name: "" } });
                state.Operator = operator;
                break;
            case 4:
                var inArticle = Comm.GetRootsWithLevel2({ session: sid });
                state.InArticle = inArticle;
                break;
            default: break;
        };


        this.setState(state);
    }


    RotateColumns(document) {
        var headings = document.getElementsByClassName("vert");
        for (var iter = 0; iter < headings.length; iter++) {
            var h = headings[iter];
            var label = h.innerText.trim();
            h.innerHTML = '';
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            context.font = h.style.font;
            context.textAlign = "right";
            context.save();
            var metrics = context.measureText(label);
            canvas.height = parseInt(metrics.width, 10);
            canvas.width = context.measureText('M').width;//най-точно приближение
            context.restore();
            context.font = h.style.font;
            //context.fillStyle = "#ff0000"; // red
            context.textAlign = "right";

            // hold top-right hand corner when rotating
            context.translate(canvas.width - 1, 0);
            //context.translate(0, 0);

            context.rotate(3 * Math.PI / 2);

            context.fillText(label, 0, 0);
            h.appendChild(canvas);

        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.RotateColumns(document);
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }

        if (Context.RenderNotOK(this.props.history))
            return null;

        console.log("DA STATE", this.state);



        return (
            Context.HasRight("rwarehousequery") ?
                <div className="panel panel-default">
                    <div className="panel-heading">{Translation.Trans("production")}</div>
                    <div className="panel-body">
                        <div className="col-md-3">
                            <button className={this.state.Q === "Q1" ? "btn btn-warning fullwidth" : "btn btn-default fullwidth"} onClick={() => this.ShowQ(1)}>
                                <p>{Translation.Trans("sorting")}</p>
                            </button>
                        </div>
                        <div className="col-md-3">
                            <button className={this.state.Q === "Q2" ? "btn btn-warning fullwidth" : "btn btn-default fullwidth"} onClick={() => this.ShowQ(2)}>
                                <p>{Translation.Trans("availability")}</p>
                            </button>
                        </div>
                        <div className="col-md-3">
                            <button className={this.state.Q === "Q3" ? "btn btn-warning fullwidth" : "btn btn-default fullwidth"} onClick={() => this.ShowQ(3)}>
                                <p>{Translation.Trans("scales")}</p>
                            </button>
                        </div>
                        <div className="col-md-3">
                            <button className={this.state.Q === "Q4" ? "btn btn-warning fullwidth" : "btn btn-default fullwidth"} onClick={() => this.ShowQ(4)}>
                                <p>{Translation.Trans("bysorters")}</p>
                            </button>


                        </div>
                        <p>&nbsp;</p>
                        <div className="row">
                            {
                                this.state.Q === "Q1" ?
                                    <div className="col-md-9">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label>{Translation.Trans("FromDate")}</label>
                                                <Datetime
                                                    inputProps={{ placeholder: 'N/A', readOnly: true, className: "form-control pointhand" }}
                                                    dateFormat="DD.MM.YYYY"
                                                    timeFormat="HH:mm:ss"
                                                    onChange={this.ChangeStartDate}
                                                    value={this.state.StartDate}
                                                    closeOnSelect={true}
                                                ></Datetime>

                                            </div>
                                            <div className="col-md-4">
                                                <label>{Translation.Trans("ToDate")}</label>
                                                <Datetime
                                                    inputProps={{ placeholder: 'N/A', readOnly: true, className: "form-control pointhand" }}
                                                    dateFormat="DD.MM.YYYY"
                                                    timeFormat="HH:mm:ss"
                                                    onChange={this.ChangeEndDate}
                                                    value={this.state.EndDate}
                                                    closeOnSelect={true}
                                                ></Datetime>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="checkbox">
                                                    <input id="cbGroup" type="checkbox" />

                                                    <label htmlFor="cbGroup">{Translation.Trans("GroupArticles")}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label htmlFor="ddlSorter">{Translation.Trans("sorter")}</label>
                                                <select id="ddlSorter" className="form-control">
                                                    {this.state.Sorter.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label htmlFor="ddlRoot">{Translation.Trans("root")}</label>
                                                <select id="ddlRoot" className="form-control">
                                                    {this.state.Root.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
                                                </select>
                                            </div>
                                            {
                                                this.state.GroupByLead &&
                                                <div className="col-md-4">
                                                    <label htmlFor="ddlUser">{Translation.Trans("user")}</label>
                                                    <select id="ddlUser" className="form-control">
                                                        {this.state.Users.map(item => <option key={item.id} value={item.id}>{item.username}</option>)}
                                                    </select>
                                                </div>
                                            }

                                            {
                                                +process.env.REACT_APP_SHOW_PERCENT_CHECK_IN_WAREHOUSE_REPORT === 1 &&
                                                <div className="col-md-3">
                                                    <div className="checkbox">
                                                        <input id="cbShowQty" type="checkbox" value={this.state.ShowQty} onChange={(e) => this.setState({ "ShowQty": e.target.checked })} />

                                                        <label htmlFor="cbShowQty">{Translation.Trans("showqty")}</label>
                                                    </div>
                                                </div>
                                            }

                                        </div>
                                    </div>
                                    : null

                            }
                            {
                                this.state.Q === "Q2" ?
                                    <div className="col-md-9">
                                        <div className="col-md-4">
                                            <label>{Translation.Trans("date")}</label>
                                            <Datetime
                                                inputProps={{ placeholder: 'N/A', readOnly: true, className: "form-control pointhand" }}
                                                dateFormat="DD.MM.YYYY"
                                                timeFormat="HH:mm:ss"
                                                onChange={this.ChangeEndDate}
                                                value={this.state.EndDate}
                                                closeOnSelect={true}
                                            ></Datetime>

                                        </div>

                                    </div>
                                    : null

                            }
                            {
                                this.state.Q === "Q3" ?
                                    <div className="col-md-9">
                                        <div className="col-md-4">
                                            <label>{Translation.Trans("FromDate")}</label>

                                            <Datetime
                                                inputProps={{ placeholder: 'N/A', readOnly: true, className: "form-control pointhand" }}
                                                dateFormat="DD.MM.YYYY"
                                                timeFormat="HH:mm:ss"
                                                onChange={this.ChangeStartDate}
                                                value={this.state.StartDate}
                                                closeOnSelect={true}
                                            ></Datetime>
                                        </div>
                                        <div className="col-md-4">
                                            <label>{Translation.Trans("ToDate")}</label>
                                            <Datetime
                                                inputProps={{ placeholder: 'N/A', readOnly: true, className: "form-control pointhand" }}
                                                dateFormat="DD.MM.YYYY"
                                                timeFormat="HH:mm:ss"
                                                onChange={this.ChangeEndDate}
                                                value={this.state.EndDate}
                                                closeOnSelect={true}
                                            ></Datetime>

                                        </div>
                                        <div className="col-md-4">
                                            <div className="checkbox">
                                                <input id="cbWithShoes" type="checkbox" />

                                                <label htmlFor="cbWithShoes">{Translation.Trans("withshoes")}</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="ddlOperator">{Translation.Trans("operator")}</label>
                                            <select id="ddlOperator" className="form-control">
                                                {this.state.Operator.map(item => <option key={item.operator.id} value={item.operator.id}>{item.operator.name}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    : null

                            }
                            {
                                this.state.Q === "Q4" ?
                                    <div className="col-md-9">
                                        <div className="col-md-4">
                                            <label>{Translation.Trans("FromDate")}</label>
                                            <Datetime
                                                inputProps={{ placeholder: 'N/A', readOnly: true, className: "form-control pointhand" }}
                                                dateFormat="DD.MM.YYYY"
                                                timeFormat="HH:mm:ss"
                                                onChange={this.ChangeStartDate}
                                                value={this.state.StartDate}
                                                closeOnSelect={true}
                                            ></Datetime>

                                        </div>
                                        <div className="col-md-4">
                                            <label>{Translation.Trans("ToDate")}</label>
                                            <Datetime
                                                inputProps={{ placeholder: 'N/A', readOnly: true, className: "form-control pointhand" }}
                                                dateFormat="DD.MM.YYYY"
                                                timeFormat="HH:mm:ss"
                                                onChange={this.ChangeEndDate}
                                                value={this.state.EndDate}
                                                closeOnSelect={true}
                                            ></Datetime>

                                        </div>
                                        <div className="col-md-4">
                                            <div className="checkbox">
                                                <input id="cbPercent" type="checkbox" />

                                                <label htmlFor="cbPercent">{Translation.Trans("inpercent")}</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="ddlInArticle">{Translation.Trans("inputarticle")}</label>
                                            <select id="ddlInArticle" className="form-control">
                                                {this.state.InArticle.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    : null

                            }
                            <div className="col-md-3">
                                <div className="btn-toolbar">
                                    <button className="btn btn-primary fullwidth" onClick={() => this.Report(null)}>
                                        <i className="fa fa-table"></i>
                                        <p>{Translation.Trans("report")}</p>
                                    </button>
                                    {
                                        this.state.Q === "Q2" ?
                                            <button className="btn btn-primary fullwidth" onClick={() => this.Report("currentavailability")}>
                                                <i className="fa fa-table"></i>
                                                <p>{Translation.Trans("currentavailability")}</p>
                                            </button>
                                            : null
                                    }
                                    {/* {
                                        this.state.Q === "Q3" ?
                                            <button className="btn btn-primary" onClick={() => this.Report("manualenter")}>
                                                <i className="fa fa-table"></i>
                                                <p>{Translation.Trans("manualenter")}</p>
                                            </button>
                                            : null
                                    } */}
                                    {
                                        this.state.Q === "Q3" ?
                                            <button className="btn btn-primary fullwidth" onClick={() => this.Report("total")}>
                                                <i className="fa fa-table"></i>
                                                <p>{Translation.Trans("total")}</p>
                                            </button>
                                            : null
                                    }
                                    {
                                        this.state.html ?
                                            [
                                                <button className="btn btn-primary fullwidth" onClick={this.PrintElem}>
                                                    <i className="fa fa-print"></i>
                                                    <p>{Translation.Trans("print")}</p>
                                                </button>,
                                                <button className="btn btn-primary fullwidth" onClick={this.Export}>
                                                    <i className="fas fa-table"></i>
                                                    <p>{Translation.Trans("export")}</p>
                                                </button>
                                            ]
                                            : null
                                    }


                                </div>
                            </div>
                        </div>
                        {
                            this.state.html && !(this.state.GroupByLead && this.state.Q === "Q1") &&
                            <div id="dReport" dangerouslySetInnerHTML={{ __html: this.state.html.replace(/table table-striped/, "stripedTable") }}>
                            </div>
                        }
                        {
                            this.state.jsonResult && this.state.GroupByLead && this.state.Q === "Q1" &&
                            <table width="100%" border="0" className="table table-striped" id="tabJsonResult">
                                <tbody>
                                    <tr>
                                        <th style={{ 'textAlign': 'left' }}>{Translation.Trans("good")}</th>
                                        <th style={{ 'textAlign': 'left' }}>{Translation.Trans("operator")}</th>
                                        <th style={{ 'textAlign': 'right' }}>{Translation.Trans("quantity")}</th>
                                        <th style={{ 'textAlign': 'right' }}>{Translation.Trans("percent")}</th>
                                    </tr>
                                    <tr>
                                        <td colSpan="6"><hr style={{ 'marginTop': '0px', 'marginBottom': '0px' }} /></td>
                                    </tr>
                                    {
                                        this.state.jsonResult.map((arr, j) =>
                                            arr.result.map(i =>
                                                <tr key={`${i.article}-${j}`}>
                                                    <td width="25%" style={{ 'textAlign': 'left' }}> {i.article}</td>
                                                    <td width="25%" style={{ 'textAlign': 'left' }}> {i.sorter}</td>
                                                    <td width="25%" style={{ 'textAlign': 'right' }}>{i.qty}</td>
                                                    <td width="25%" style={{ 'textAlign': 'right' }}>{i.perc}</td>
                                                </tr>
                                            )
                                        )
                                    }
                                </tbody>
                            </table>
                        }

                    </div>
                </div>
                :
                <div>{Translation.Trans("noRights")}</div>

        );
    }

}


export default WarehouseQuery;


// WEBPACK FOOTER //
// ./src/pages/warehousequery.js